/**
 * Welcome/Task Guide API Client
 *
 * Provides access to the task guide system that returns
 * evaluated onboarding tasks based on user/org state.
 */

import { apiFetch } from './common';
import type { TaskGuideResponse } from '../../types/taskGuide';

/**
 * Response from POST /api/v1/welcome/conditions/{id}/dismiss
 */
export interface DismissTaskResponse {
  status: string;
  taskId: string;
}

/**
 * Welcome/Task Guide API methods
 */
export const WelcomeAPI = {
  /**
   * Get evaluated onboarding tasks for the task guide widget.
   */
  async getTasks(): Promise<TaskGuideResponse> {
    return apiFetch<TaskGuideResponse>('/api/v1/welcome/conditions');
  },

  /**
   * Dismiss a task (if dismissible)
   */
  async dismissTask(taskId: string): Promise<DismissTaskResponse> {
    return apiFetch<DismissTaskResponse>(`/api/v1/welcome/conditions/${taskId}/dismiss`, {
      method: 'POST',
    });
  },
};
